import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCenteredCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "m3.094 1.68 1.43 1.43A5.97 5.97 0 0 1 8 2c1.296 0 2.496.41 3.476 1.11l1.43-1.43A7.97 7.97 0 0 0 8 0C6.151 0 4.45.627 3.094 1.68M2 8c0-1.296.41-2.496 1.11-3.477L1.68 3.094A7.97 7.97 0 0 0 0 8c0 1.849.627 3.55 1.68 4.906l1.43-1.43A5.97 5.97 0 0 1 2 8m6 6c1.296 0 2.496-.41 3.477-1.11l1.429 1.43A7.97 7.97 0 0 1 8 16a7.97 7.97 0 0 1-4.906-1.68l1.43-1.43C5.503 13.59 6.703 14 8 14m6.32-1.094-1.43-1.43A5.97 5.97 0 0 0 14 8c0-1.296-.41-2.496-1.11-3.477l1.43-1.429A7.97 7.97 0 0 1 16 8c0 1.849-.627 3.55-1.68 4.906M8 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8"
	})
});
export default SvgCenteredCircle;
